<template>
  <div class="text-center text-xs text-gray-500">Version 1.0.0</div>
</template>
